import { createContext } from "react";

const ApplicationEntryProgressContext = createContext<any>({});

export default ApplicationEntryProgressContext;
